"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../DomainObject");
/*
 * Created on Fri Aug 03 2018
 */

/**
 * Codebook item with identifier and title for UI.
 *
 * @author Radek Beran
 */


var CodebookItem =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CodebookItem, _DomainObject_1$Domai);

  /**
   * @param id
   * @param title
   * @param description
   * @param flags for filtering codebook items according to desired usage in service logic.
   * @param externalId
   */
  function CodebookItem(id, title) {
    var _this;

    var description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var flags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : immutable_1.List();
    var externalId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    _classCallCheck(this, CodebookItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CodebookItem).call(this));
    _this.id = id;
    _this.title = title;
    _this.description = description;
    _this.flags = flags;
    _this.externalId = externalId;
    return _this;
  }

  return CodebookItem;
}(DomainObject_1.DomainObject);

exports.CodebookItem = CodebookItem;
/**
 * Schema for plain codebook item if no extension of CodebookItem is used.
 */
// tslint:disable-next-line:member-ordering

CodebookItem.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CodebookItem.name);
  return {
    id: builder.id('id'),
    title: builder.str('title'),
    description: builder.opt(builder.str('description')),
    flags: builder.listOf(builder.str('flags')),
    externalId: builder.opt(builder.str('externalId'))
  };
}();